import React, {
  useState,
  useEffect,
  useMemo,
  useRef,
  createContext,
} from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { PrivateRoute } from '../../components/PrivateRoute';
import { Auth } from 'aws-amplify';
import { CreateVendor } from '../../pages/admin/vendor/CreateVendor/CreateVendor';
import { EditVendor } from '../../pages/admin/vendor/EditVendor/EditVendor';
import { ManageUser } from '../../pages/admin/user/ManageUser';
import { ManageVendors } from '../../pages/admin/vendor/ManageVendors/ManageVendors';
import { CreateUser } from '../../pages/admin/user/CreateUser/CreateUser';
import { EditUser } from '../../pages/admin/user/EditUser';
import { BrokerView } from '../../pages/admin/broker/BrokerView';
import { VendorAdminHome } from '../../components/VendorAdmin/VendorAdminHome';
import { MyProfile } from '../../pages/profile/MyProfile';
import { FAQs } from '../../pages/FAQs/faqs';
import { Training } from '../../pages/trainingpage/training';
import { Home } from '../../pages/reports/Home/Home';
import { QuickFacts } from '../../pages/reports/QuickFacts/QuickFacts';
import { VoidReport } from '../../pages/reports/VoidReport/VoidReport';
import { WeeklyTrend } from '../../pages/reports/WeeklyTrend/WeeklyTrend';
import { SupplierPerformance } from '../../pages/reports/SupplierPerformance/SupplierPerformance';
import { FourYearTrend } from '../../pages/reports/FourYearTrend/FourYearTrend';
import { QBRs } from '../../pages/reports/QBRs/QBRs';
import { ServiceAndInventory } from '../../pages/reports/ServiceAndInventory/ServiceAndInventory';
import { ContactDirectory } from '../../pages/reports/ContactDirectory/ContactDirectory';
import { Produce } from '../../pages/reports/Produce/Produce';
import { Forecasts } from '../../pages/reports/Forecasts/Forecasts';
import { Credit } from '../../pages/reports/Credit';
import { Compliance } from '../../pages/reports/Compliance';
import { Purchasing } from '../../pages/reports/PurchasingAndSales/Purchasing';
import { Sales } from '../../pages/reports/PurchasingAndSales/sales';
import {
  getCannedTimeframeArr,
  getDatesPreviousYear,
} from '../../utils/dateUtils';
import { useIdleTimer } from '../../utils/IdleTimer';
import { authorizeUser } from '../../utils/helpers';
import { CustomerDataSubscription } from '../../pages/reports/CustomerDataSubscription/CustomerDataSubscription';
import { Manage } from '../../components/VendorAdmin/Manage';
import { SupplierAdminPortal } from '../../components/SupplierAdmin/SupplierAdminPortal';
import { CreateUserBySupplierAdmin } from '../../components/SupplierAdmin/CreateUserBySupplierAdmin';
import { EditUserBySupplierAdmin } from '../../components/SupplierAdmin/EditUserBySupplierAdmin';
import { PendingLicenseApprovals } from '../../components/SupplierAdmin/PendingLicenseApprovals';
import usersService from '../../axios/usersService';
import HeaderAppBar from '../../layouts/HeaderAppbar';
import RoleError from '../../pages/errors/RoleError';
import Error from '../../pages/errors/Error';
import PolicyModal from '../../components/PolicyModal';
import NPSPopup from '../../components/NPSPopup';
import featureToggle from '../../featureToggle.json';

export const FiltersContext = createContext();

const isQbrsEnabled =
  featureToggle?.[process.env.REACT_APP_ENVIRONMENT]?.['qbrs'];

export default function ApplicationRoutes() {
  const [policyAccepted, setPolicyAccepted] = useState(null);
  const [policyChecking, setPolicyChecking] = useState(true);
  const [filterPageOpen, setFilterPageOpen] = useState(false);
  const [embedRefreshTrigger, setEmbedRefreshTrigger] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [isVendor, setIsVendor] = useState(false);
  const [vendorGroupNumber, setVendorGroupNumber] = useState(null);
  const [isBroker, setIsBroker] = useState(false);
  const [roleError, setRoleError] = useState(false);
  const [isReset, setIsReset] = useState(true);
  const [impersonatorInfo, setImpersonatorInfo] = useState({});
  const [viewType, setViewType] = useState('basic');
  const [basicFilters, setBasicFilters] = useState({});
  const [insightsFilters, setInsightsFilters] = useState({});
  const [customerFilters, setCustomerFilters] = useState({});
  const [purchaseFilters, setPurchaseFilters] = useState({});
  const [qbrFilters, setQbrFilters] = useState({});
  const [basicWorkbookControlData, setBasicWorkbookControlData] = useState({});
  const [insightsWorkbookControlData, setInsightsWorkbookControlData] =
    useState({});
  const [homeWorkbookControlData, setHomeWorkbookControlData] = useState({});
  const [quickFactsWorkbookControlData, setQuickFactsWorkbookControlData] =
    useState({});
  const [voidReportWorkbookControlData, setVoidReportWorkbookControlData] =
    useState({});
  const [weeklyWorkbookControlData, setWeeklyWorkbookControlData] = useState(
    {},
  );
  const [customerWorkbookControlData, setCustomerWorkbookControlData] =
    useState({});
  const [qbrWorkbookControlData, setQbrWorkbookControlData] = useState({});
  const [sldWorkbookControlData, setSldWorkbookControlData] = useState({});
  const [
    contactDirectoryWorkbookControlData,
    setContactDirectoryWorkbookControlData,
  ] = useState({});
  const [sipWorkbookControlData, setSipWorkbookControlData] = useState({});
  const [sifWorkbookControlData, setSifWorkbookControlData] = useState({});
  const [purchaseWorkbookControlData, setPurchaseWorkbookControlData] =
    useState({});
  const [salesWorkbookControlData, setSalesWorkbookControlData] = useState({});
  const [yearlyWorkbookControlData, setYearlyWorkbookControlData] = useState(
    {},
  );
  const [
    supplierPerformanceBasicWorkbookControlData,
    setSupplierPerformanceBasicWorkbookControlData,
  ] = useState({});
  const [
    supplierPerformanceInsightsWorkbookControlData,
    setSupplierPerformanceInsightsWorkbookControlData,
  ] = useState({});
  const [basicFiltersNameInput, setBasicFiltersNameInput] = useState('');
  const [insightsFiltersNameInput, setInsightsFiltersNameInput] = useState('');
  const [customerFiltersNameInput, setCustomerFiltersNameInput] = useState('');
  const [purchaseFiltersNameInput, setPurchaseFiltersNameInput] = useState('');
  const [qbrFiltersNameInput, setQbrFiltersNameInput] = useState('');
  const [sldWeekly, setSldWeekly] = useState(false);
  const [contactDirectoryDetails, setContactDirectoryDetails] = useState(false);
  const [sipWeekly, setSipWeekly] = useState(false);
  const [sicWeekly, setSicWeekly] = useState(false);
  const [creditTab, setCreditTab] = useState(0); // Credit is the name for the internal version of the Compliance report.
  const [subId, setSubId] = useState(1);
  const [cannedReport, setCannedReport] = useState('52');
  const [currentTimeframe, setCurrentTimeframe] = useState(
    getCannedTimeframeArr(cannedReport),
  );
  const [previousTimeframe, setPreviousTimeframe] = useState(
    getDatesPreviousYear(cannedReport, currentTimeframe, false),
  );
  const [weekSelection, setWeekSelection] = useState(cannedReport);
  const [switchOn, setSwitchOn] = useState(false);
  const [embedDidLoad, setEmbedDidLoad] = useState(false);
  const [filterPageData, setFilterPageData] = useState({});
  const [showNps, setShowNps] = useState(false);
  const [npsChecked, setNpsChecked] = useState(false);

  const savedFiltersNameBasic = useRef(null);
  const savedFiltersNameInsights = useRef(null);
  const savedFiltersNameCustomer = useRef(null);
  const savedFiltersNamePurchase = useRef(null);
  const savedFiltersNameQbr = useRef(null);

  // Here, the page isn't created so we need to get the current page with useLocation
  const location = useLocation();
  const isQbrHome = isQbrsEnabled && location.pathname === '/';

  // var passed to FilterConfigMenu component to persist through modal close | open
  const savedFiltersName = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? savedFiltersNameCustomer
        : location.pathname.includes('/purchasing')
          ? savedFiltersNamePurchase
          : isQbrHome
            ? savedFiltersNameQbr
            : viewType === 'basic'
              ? savedFiltersNameBasic
              : savedFiltersNameInsights,
    [viewType, location.pathname],
  );
  const filters = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? customerFilters
        : location.pathname.includes('/purchasing')
          ? purchaseFilters
          : isQbrHome
            ? qbrFilters
            : viewType === 'basic'
              ? basicFilters
              : insightsFilters,
    [
      viewType,
      location.pathname,
      basicFilters,
      insightsFilters,
      customerFilters,
      purchaseFilters,
      qbrFilters,
    ],
  );
  const workbookControlData = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? customerWorkbookControlData
        : location.pathname.includes('/purchasing')
          ? purchaseWorkbookControlData
          : isQbrHome
            ? qbrWorkbookControlData
            : viewType === 'basic'
              ? basicWorkbookControlData
              : insightsWorkbookControlData,
    [
      viewType,
      location.pathname,
      basicWorkbookControlData,
      insightsWorkbookControlData,
      customerWorkbookControlData,
      purchaseWorkbookControlData,
      qbrWorkbookControlData,
    ],
  );
  const filtersNameInput = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? customerFiltersNameInput
        : location.pathname.includes('/purchasing')
          ? purchaseFiltersNameInput
          : isQbrHome
            ? qbrFiltersNameInput
            : viewType === 'basic'
              ? basicFiltersNameInput
              : insightsFiltersNameInput,
    [
      viewType,
      location.pathname,
      basicFiltersNameInput,
      insightsFiltersNameInput,
      customerFiltersNameInput,
      purchaseFiltersNameInput,
      qbrFiltersNameInput,
    ],
  );
  const setFilters = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? setCustomerFilters
        : location.pathname.includes('/purchasing')
          ? setPurchaseFilters
          : isQbrHome
            ? setQbrFilters
            : viewType === 'basic'
              ? setBasicFilters
              : setInsightsFilters,
    [viewType, location.pathname],
  );
  const setWorkbookControlData = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? setCustomerWorkbookControlData
        : location.pathname.includes('/purchasing')
          ? setPurchaseWorkbookControlData
          : isQbrHome
            ? setQbrWorkbookControlData
            : viewType === 'basic'
              ? setBasicWorkbookControlData
              : setInsightsWorkbookControlData,
    [viewType, location.pathname],
  );
  const setFiltersNameInput = useMemo(
    () =>
      location.pathname.includes('/customer-data')
        ? setCustomerFiltersNameInput
        : location.pathname.includes('/purchasing')
          ? setPurchaseFiltersNameInput
          : isQbrHome
            ? setQbrFiltersNameInput
            : viewType === 'basic'
              ? setBasicFiltersNameInput
              : setInsightsFiltersNameInput,
    [viewType, location.pathname],
  );

  const channel = new BroadcastChannel('shared-table');
  channel.addEventListener('message', () => {});
  channel.onmessage = function () {
    Auth.signOut();
  };

  const handleResetFilters = (page) => {
    setBasicFilters({});
    setInsightsFilters({});
    setCustomerFilters({});
    setPurchaseFilters({});
    setQbrFilters({});
    switch (page) {
      case 'cdq':
        setQuickFactsWorkbookControlData({});
        break;
      case 'qbrs':
        setQbrWorkbookControlData({});
        break;
      case 'vr':
        setVoidReportWorkbookControlData({});
        break;
      case 'weekly':
        setWeeklyWorkbookControlData({});
        break;
      case 'customer-data':
        setCustomerWorkbookControlData({});
        break;
      case 'purchase':
        setPurchaseWorkbookControlData({});
        break;
      default:
        setQuickFactsWorkbookControlData({});
        setVoidReportWorkbookControlData({});
        setWeeklyWorkbookControlData({});
        setPurchaseWorkbookControlData({});
        setCustomerWorkbookControlData({});
        break;
    }

    setIsReset(!isReset);
    setFiltersNameInput(null);
    savedFiltersName.current = '';
  };

  //Validation of the user credentials
  useEffect(() => {
    authorizeUser(setIsAdmin, setRoleError, setViewType, setIsVendor, setVendorGroupNumber, setIsBroker);
  }, []);

  useEffect(() => {
    async function checkPolicyStatus() {
      try {
        setPolicyChecking(true);
        const policyStatus =
          await usersService.getComplianceContractAgreement();
        // Only show modal if we explicitly get false from the API
        // Default to not showing modal on any errors, null, undefined, or other falsy responses
        if (policyStatus === false) {
          setPolicyAccepted(false); // Show modal
        } else {
          setPolicyAccepted(true); // Don't show modal (handles undefined, null, true, etc.)
        }
      } catch (error) {
        console.error('Error checking policy status:', error);
        // Default to not showing modal on error
        setPolicyAccepted(true);
      } finally {
        setPolicyChecking(false);
      }
    }

    checkPolicyStatus();
  }, []);

  useEffect(() => {
    async function evaluateNpsVisibility() {
      try {
        const env = process.env.REACT_APP_ENVIRONMENT;
        const npsEnabled = featureToggle?.[env]?.['nps-modal'];
        if (!npsEnabled) {
          setShowNps(false);
          return;
        }

        const hasLoggedInBefore = await usersService.getHasLoggedInBefore();
        if (!hasLoggedInBefore) {
          setShowNps(false);
          return;
        }

        const hasSubmitted = await usersService.getHasSubmittedNps();
        if (hasSubmitted) {
          setShowNps(false);
          return;
        }

        setShowNps(true);
      } catch (e) {
        setShowNps(false);
      } finally {
        setNpsChecked(true);
      }
    }

    evaluateNpsVisibility();
  }, []);

  const handlePolicyAccept = async () => {
    console.log('Policy accepted');
    const res = await usersService.signComplianceContractAgreement();
    setPolicyAccepted(res);
  };

  useEffect(() => {
    async function fetchID() {
      const subIdRes = await usersService.getSubId();
      setSubId(subIdRes);
    }
    fetchID();
  }, []);

  useIdleTimer(channel);

  if (policyChecking) {
    return <div>Loading...</div>;
  }

  if (!policyAccepted) {
    return <PolicyModal open={true} onAccept={handlePolicyAccept} />;
  }

  return (
    <>
      <FiltersContext.Provider
        value={{
          channel,
          isAdmin,
          isVendor,
          vendorGroupNumber,
          isBroker,
          savedFiltersName,
          subId,
          filtersNameInput,
          setFiltersNameInput,
          filters,
          setFilters,
          insightsWorkbookControlData,
          setInsightsWorkbookControlData,
          workbookControlData,
          setWorkbookControlData,
          homeWorkbookControlData,
          setHomeWorkbookControlData,
          quickFactsWorkbookControlData,
          setQuickFactsWorkbookControlData,
          voidReportWorkbookControlData,
          setVoidReportWorkbookControlData,
          weeklyWorkbookControlData,
          setWeeklyWorkbookControlData,
          sldWorkbookControlData,
          setSldWorkbookControlData,
          contactDirectoryWorkbookControlData,
          setContactDirectoryWorkbookControlData,
          sipWorkbookControlData,
          setSipWorkbookControlData,
          sifWorkbookControlData,
          setSifWorkbookControlData,
          purchaseWorkbookControlData,
          setPurchaseWorkbookControlData,
          salesWorkbookControlData,
          setSalesWorkbookControlData,
          yearlyWorkbookControlData,
          setYearlyWorkbookControlData,
          customerWorkbookControlData,
          setCustomerWorkbookControlData,
          qbrWorkbookControlData,
          setQbrWorkbookControlData,
          viewType,
          setViewType,
          isReset,
          setIsReset,
          sldWeekly,
          setSldWeekly,
          contactDirectoryDetails,
          setContactDirectoryDetails,
          creditTab,
          setCreditTab,
          sicWeekly,
          setSicWeekly,
          sipWeekly,
          setSipWeekly,
          weekSelection,
          setWeekSelection,
          impersonatorInfo,
          setImpersonatorInfo,
          cannedReport,
          setCannedReport,
          currentTimeframe,
          setCurrentTimeframe,
          previousTimeframe,
          setPreviousTimeframe,
          switchOn,
          setSwitchOn,
          filterPageOpen,
          setFilterPageOpen,
          embedRefreshTrigger,
          setEmbedRefreshTrigger,
          supplierPerformanceBasicWorkbookControlData,
          setSupplierPerformanceBasicWorkbookControlData,
          supplierPerformanceInsightsWorkbookControlData,
          setSupplierPerformanceInsightsWorkbookControlData,
          handleResetFilters,
          embedDidLoad,
          setEmbedDidLoad,
          setSubId,
          filterPageData,
          setFilterPageData,
        }}
      >
        {roleError ? <RoleError /> : <HeaderAppBar />}
        <Routes>
          <Route
            path="/"
            element={
              isQbrsEnabled ? <QBRs page={'qbrs'} /> : <Home page={'home'} />
            }
          />
          <Route path="/quick-facts" element={<QuickFacts page={'cdq'} />} />
          <Route path="/void-report" element={<VoidReport page={'vr'} />} />
          <Route
            path="/weekly-trend"
            element={<WeeklyTrend page={'weekly'} />}
          />
          <Route
            path="/supplier-performance"
            element={<SupplierPerformance page={'fsr'} />}
          />
          <Route
            path="/4-year-trend"
            element={<FourYearTrend page={'yearly'} />}
          />
          <Route
            path="/service-and-inventory"
            element={<ServiceAndInventory page={'sld'} />}
          />
          <Route
            path="/contact-directory"
            element={<ContactDirectory page={'contact-directory'} />}
          />
          <Route path="/produce" element={<Produce page={'sip'} />} />
          <Route path="/forecasts" element={<Forecasts page={'sif'} />} />
          <Route
            path="/compliance"
            element={<Compliance page={'compliance'} />}
          />
          <Route path="/credit" element={<Credit page={'credit'} />} />
          <Route
            path="/purchasing"
            element={<Purchasing page={'purchase'} />}
          />
          <Route path="/sales" element={<Sales page={'sales'} />} />
          <Route
            path="/customer-data"
            element={<CustomerDataSubscription page={'customer-data'} />}
          />
          <Route element={<PrivateRoute isAdmin={isAdmin} />}>
            <Route path="/create-vendor" element={<CreateVendor />} />
            <Route path="/edit-vendor" element={<EditVendor />} />
            <Route path="/create-user" element={<CreateUser />} />
            <Route path="/manage-user" element={<ManageUser />} />
            <Route path="/manage-vendor" element={<ManageVendors />} />
            <Route
              path="/manage-broker"
              element={<Manage userGroup={'broker'} />}
            />
            <Route path="/vendor-admin" element={<VendorAdminHome />} />
            <Route path="/edit-user" element={<EditUser />} />
            <Route path="/add-broker" element={<BrokerView action={'add'} />} />
            <Route
              path="/edit-broker"
              element={<BrokerView action={'edit'} />}
            />
            <Route
              path="/pending-license-approvals"
              element={<PendingLicenseApprovals />}
            />
          </Route>
          <Route path="/supplier-admin" element={<SupplierAdminPortal />} />
          <Route
            path="/supplier-admin/create-user"
            element={<CreateUserBySupplierAdmin />}
          />
          <Route
            path="/supplier-admin/edit-user"
            element={<EditUserBySupplierAdmin />}
          />
          <Route path="/profile" element={<MyProfile />} />
          <Route path="/error" element={<Error />} />
          <Route path="/faqs" element={<FAQs />} sx={{ overflow: 'scroll' }} />
          <Route path="/training" element={<Training />} />
        </Routes>
        {npsChecked && showNps && (
          <NPSPopup
            open={true}
            onClose={() => setShowNps(false)}
            onSubmitted={() => setShowNps(false)}
          />
        )}
      </FiltersContext.Provider>
    </>
  );
}
